import Vue from 'vue';
import Vuex from 'vuex';
import router from './router';

Vue.use(Vuex);

export default new Vuex.Store({
    actions: {
        reLogin: function(context) {
            context.commit('logout');
            router.push({
                path: '/'
            });
        }
    },
    mutations: {
        login: function(state, payload) {
            state.user = payload.user;
            state.userToken = payload.userToken;
            localStorage.setItem('user', JSON.stringify(payload.user));
            localStorage.setItem('token', payload.userToken);
        },
        logout: function(state) {
            state.userToken = '';
            state.user = null;
            localStorage.removeItem('user');
            localStorage.removeItem('token');
        }
    },
    state: {
        alerts: [],
        user: localStorage.getItem('user')
            ? JSON.parse(localStorage.getItem('user'))
            : null,
        userToken: localStorage.getItem('token')
            ? localStorage.getItem('token')
            : ''
    }
});
